var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Card',{class:_vm.$style.root,attrs:{"radius":"m","radius-side":"all"}},[_c('AnimatedTransition',{class:_vm.$style.grow},[_c(_vm.stateName,{tag:"component",class:_vm.$style.grow})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }